import { useEffect } from "react";

const ACADEMY_URL = "https://freshvisionacademy.org/";

/**
 * /academy has one identity: Fresh Vision Academy at freshvisionacademy.org.
 * Vercel issues a permanent server-side redirect; this handles in-app
 * navigations that never touch the server.
 */
const AcademyRedirect = () => {
  useEffect(() => {
    window.location.replace(ACADEMY_URL);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="text-center">
        <p className="text-muted-foreground mb-3">Taking you to Fresh Vision Academy.</p>
        <a href={ACADEMY_URL} className="text-accent font-semibold underline">
          Continue to freshvisionacademy.org
        </a>
      </div>
    </div>
  );
};

export default AcademyRedirect;
